import { ReactElement, useState } from 'react';

import { useDentistsContext } from '../';
import { Button } from '../../Button';
import { SearchIcon } from '../../icons/SearchIcon';
import { Select } from '../../Select';
import Map from '../MapStage/DentistsFound/Map';
import PlanForm from './PlanForm';
import QuestionBox from './QuestionBox';

export default function SearchStage(): ReactElement {
  const [isLoading, setIsLoading] = useState(false);

  const { specialties, specialty, setSpecialty, canSearch, handleSearch } =
    useDentistsContext();

  const handleSearchClick = async () => {
    setIsLoading(true);
    try {
      await handleSearch();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-5 space-y-5">
      <div className="rounded-lg bg-primary-container2 p-5">
        <div className="grid gap-5 min-[1040px]:grid-cols-[minmax(0,1fr)_auto_minmax(280px,0.55fr)] min-[1040px]:items-start">
          <div className="min-w-0">
            <h3 className="mb-3 text-2xl font-normal text-high-emphasis max-[1300px]:text-lg">
              Ainda n&atilde;o sabe qual especialidade procurar?
            </h3>
            <QuestionBox />
          </div>

          <p className="self-center text-center text-sm font-semibold uppercase text-primary-main max-[1039px]:text-left">
            Ou
          </p>

          <div className="min-w-0">
            <h3 className="mb-3 text-2xl font-normal text-high-emphasis max-[1300px]:text-lg">
              Escolha a especialidade
            </h3>
            <Select
              label=""
              enablePlaceholder
              options={[]}
              optionsFull={specialties.map(s => ({
                Id: s.idEspecialidade,
                Sigla: s.nomeEspecialidade,
              }))}
              value={specialty?.idEspecialidade || ''}
              onChange={(c: { target: { value: string | number } }) =>
                setSpecialty(
                  specialties.find(s => s.idEspecialidade === +c.target.value),
                )
              }
              placeholder="Selecione"
            />
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-neutral-lightest bg-neutral-white p-5">
        <div className="flex items-end gap-5 max-[900px]:flex-col max-[900px]:items-stretch">
          <PlanForm />
          <Button
            disabled={!canSearch || isLoading}
            text={isLoading ? 'Buscando...' : 'Buscar dentista'}
            onClick={handleSearchClick}
            className="min-w-[190px] disabled:bg-gray-200"
            Icon={SearchIcon}
          />
        </div>
      </div>

      <section className="overflow-hidden rounded-lg border border-neutral-lightest bg-neutral-white">
        <div className="relative overflow-hidden bg-primary-container2 px-5 py-4">
          <img
            src="/assets/images/odonto-map.png"
            alt=""
            aria-hidden="true"
            className="absolute bottom-0 right-0 h-full w-1/2 object-contain opacity-20 max-[720px]:w-full"
          />
          <div className="relative z-10 flex flex-wrap items-center justify-between gap-4">
            <div>
              <img
                src="/assets/logos/odontogroup-azul.png"
                alt="OdontoGroup"
                className="mb-3 h-9 w-auto"
              />
              <h3 className="text-xl font-semibold text-primary-main">
                Rede credenciada
              </h3>
            </div>
            <p className="max-w-xl text-sm text-medium-emphasis">
              Encontre unidades por CEP, estado, cidade, bairro e especialidade.
            </p>
          </div>
        </div>

        <div className="p-4">
          <Map
            docList={[]}
            className="h-[360px] w-full overflow-hidden rounded-lg min-[900px]:h-[460px]"
            showEmptyState
          />
        </div>
      </section>
    </div>
  );
}
